module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bootstrap-modal', {
    ref: "reportModal",
    attrs: {
      "need-header": true,
      "need-footer": true,
      "closed": _vm.closedModal,
      "size": "large"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Relatório")]), _vm._v(" "), (_vm.options) ? _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('a', {
    staticClass: "btn btn-warning btn-xs",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showConfig = !_vm.showConfig
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "cog"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Opções")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row exibir-configuracoes"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showConfig),
      expression: "!showConfig"
    }],
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Selecione as seguradoras para gerar o relatório")]), _vm._v(" "), _vm._l((_vm.options.coverages), function(coverage, index) {
    return _c('div', {
      key: coverage.number,
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-6"
    }, [_c('label', {
      staticClass: "no-margin"
    }, [_vm._v("\n                  Cobertura " + _vm._s(coverage.number) + " "), (index === 0) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("ÚLTIMA CALCULADA")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('label', {
      staticClass: "custom-checkbox no-margin"
    }, [_c('input', {
      staticClass: "checkall",
      attrs: {
        "type": "checkbox",
        "checked": "index === 0"
      },
      on: {
        "change": function($event) {
          _vm.checkInsurers($event, coverage.prices)
        }
      }
    }), _vm._v("TODOS\n                  "), _c('span', {
      staticClass: "checkmark"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('label', {
      staticClass: "custom-checkbox no-margin"
    }, [_c('input', {
      staticClass: "checkall",
      attrs: {
        "id": "chbCheckProdutosAdicionais",
        "type": "checkbox",
        "checked": "index === 0"
      },
      on: {
        "change": function($event) {
          _vm.checkInsurersWithAdditionalProduct($event, coverage.prices)
        }
      }
    }), _vm._v("PRODUTOS ADICIONAIS\n                    "), _c('span', {
      staticClass: "checkmark"
    })])])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l((coverage.prices), function(price) {
      return _c('div', {
        key: price.priceId,
        staticClass: "col-xs-12 col-sm-6 col-md-3 min-card-height"
      }, [_c('div', {
        staticClass: "padding-price"
      }, [_c('div', {
        staticClass: "bording-price"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('label', {
        staticClass: "custom-checkbox"
      }, [_vm._v("\n                        " + _vm._s(price.insurer) + "\n                        "), _c('input', {
        class: {
          'checkmark': true, 'additional-products-checkmark': (price.product_additional)
        },
        attrs: {
          "type": "checkbox",
          "name": "seguradoras[]"
        },
        domProps: {
          "value": price.priceId,
          "checked": price.check
        },
        on: {
          "change": function($event) {
            price.check = !price.check
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "checkmark"
      })])]), _vm._v(" "), (price.product_additional) ? _c('div', {
        staticClass: "produto-adicional"
      }, [_c('label', {
        staticClass: "custom-checkbox"
      }, [_vm._v(" PRODUTO ADICIONAL ")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('i', {
        staticClass: "fa fa-money"
      }), _vm._v(" " + _vm._s(price.value))]), _vm._v(" "), _c('div', [_c('i', {
        staticClass: "fa fa-percent"
      }), _vm._v(" " + _vm._s(price.commission))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(price.product))])])])])])
    }))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row exibir-configuracoes"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfig),
      expression: "showConfig"
    }],
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("Selecione a quantidade de parcelas para exibir")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.parcela),
      expression: "options.parcela"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "parcela"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "parcela", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.parcelas), function(parcela) {
    return _c('option', {
      key: parcela,
      domProps: {
        "value": parcela
      }
    }, [_vm._v(_vm._s(parcela + ' ' + (parcela == 1 ? 'vez' : 'vezes')))])
  })), _vm._v(" "), _c('br')]), _vm._v(" "), ((_vm.options.residential) == false || _vm.options.residential === undefined) ? _c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("Selecione o tipo do relatório")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.relatorio),
      expression: "options.relatorio"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "relatorio"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "relatorio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.relatorios), function(value, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value))])
  })), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.options.hasLogo && !_vm.token) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "text-danger"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center !important"
    }
  }, [_vm._v("\n                            Sua corretora não possui logo cadastrada:\n                            "), _c('a', {
    attrs: {
      "href": _vm.options.corretora_edit,
      "target": "_blank"
    }
  }, [_vm._v("Adicionar")])])])]) : _vm._e(), _vm._v(" "), (!_vm.token) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "bg-warning message-attention"
  }, [_vm._v("\n                        ATENÇÃO: Nobre Corretor(a), o relatório em questão ainda está em desenvolvimento e pode conter informações divergentes em relação as seguradoras. Caso verifique que algo pode ser melhorado, favor entrar em contato conosco e informar. Agradecemos a sua ajuda e compreensão!\n                    ")])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.errors & !_vm.token) ? _c('div', {
    staticClass: "col-md-6 text-rigth",
    class: {
      'has-error': _vm.errors.has('other_email[]')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          email: true
        }
      }),
      expression: "{ rules: { email: true } }"
    }],
    staticClass: "form-control valid-email",
    attrs: {
      "type": "text",
      "name": "other_email[]",
      "placeholder": "E-mail",
      "data-vv-as": "E-mail",
      "disabled": _vm.isDetailedReport
    },
    domProps: {
      "value": _vm.options.email
    }
  }), _vm._v(" "), (_vm.errors.has('other_email[]')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('other_email[]')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-left"
  }, [(!_vm.token) ? _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button",
      "disabled": _vm.isDetailedReport
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendReportToEmail($event)
      }
    }
  }, [_vm._v("\n                Enviar por E-mail\n              ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.downloadReport($event, 'pdf')
      }
    }
  }, [_vm._v("\n                Gerar PDF\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "disabled": _vm.isDetailedReport
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.downloadReport($event, 'xls')
      }
    }
  }, [_vm._v("\n                Gerar XLS\n              ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b322d9a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/enterprise/modules/Result/PartialModalPrint.vue
// module id = 339
// module chunks = 0